const C = require("../constants");
const initial_data = {open: false, ticket:{id:null, quantity:0, checked:0, product:{name:''}}};

function TicketCheckReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TICKET_CHECK_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default TicketCheckReducer;


// WEBPACK FOOTER //
// ./src/reducers/TicketCheckReducer.js